// extracted by mini-css-extract-plugin
module.exports = {"col":"TableHeadCell_col__xiBuX","active":"TableHeadCell_active__H1JXC","icon":"TableHeadCell_icon__G34pt"};